module.exports = __webpack_public_path__ + "img/17400.0522c7f5.jpg";